import React from 'react';
import {useShallow} from 'zustand/react/shallow';
import {Stack} from '@mui/material';
import {designSystemToken, Tooltip} from '@lightricks/react-design-system';
import useUiInteractionEvent from '@contentlab/hooks/analytics/use-interaction-event';
import translate from '@/utils/translate';
import {ROUTES} from '@/config/routesConstants';
import NavLink from '@/components/nav-link';
import contentStudioStore from '@/stores/contentStudioStore';
import FeaturePageNavItem from './FeaturePageNavItem';
import {Feature} from './types';

const features: Feature[] = [
  {
    icon: 'Actions-Expand',
    label: 'Resize',
    path: ROUTES.CONTENT_LAB_REFORMAT,
  },
  {
    icon: 'Navigation-Messages',
    label: 'Dub',
    path: ROUTES.CONTENT_LAB_TRANSLATE,
  },
  {
    icon: 'Features-Rename',
    label: 'Rephrase',
    path: ROUTES.CONTENT_LAB_REPHRASE,
  },
];

function FeaturePageNavBar() {
  const {uiInteraction} = useUiInteractionEvent();
  const {isRephraseActive} = contentStudioStore(
    useShallow((state) => ({
      isRephraseActive: state.selectedAssets.length === 1,
    }))
  );
  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      gap="8px"
      width="124px"
      minWidth="124px"
      height="100vh"
      borderRight={`1px solid ${designSystemToken('semantic.bg.tertiary')}`}
      bgcolor={designSystemToken('semantic.bg.secondary')}
    >
      {features.map((feature) => {
        if (feature.path === ROUTES.CONTENT_LAB_REPHRASE && !isRephraseActive) {
          return (
            <Tooltip
              key={feature.path}
              title={translate('To rescript, select only one file')}
              arrow
              placement="right"
            >
              <span>
                <FeaturePageNavItem
                  icon={feature.icon}
                  label={translate(feature.label)}
                  isActive={false}
                  disabled
                />
              </span>
            </Tooltip>
          );
        }
        return (
          <NavLink
            to={feature.path}
            key={feature.path}
            onClick={() => {
              uiInteraction({
                item_name: feature.label,
                interaction_location: 'feature_page_nav_bar',
              });
            }}
          >
            {({isActive}) => (
              <FeaturePageNavItem
                icon={feature.icon}
                label={translate(feature.label)}
                isActive={isActive}
              />
            )}
          </NavLink>
        );
      })}
    </Stack>
  );
}

export default FeaturePageNavBar;
